import { each, isArray } from "lodash";
import { setLocalStorage, getLocalStorage } from "./utils/storage";
import { safeParseJSON } from "./utils/misc";

declare const jQuery: any;
const $ = jQuery;
const defaultActionName: string = "load_more_posts";

const SAVE_TO_LOCAL = false;

interface FetchResponse
{
	more: boolean;
	html: any[];
}

export function init()
{
	initLoadMoreButton();
}

function initLoadMoreButton(): void
{
	$(`[data-load-more-button]`).each(function () {
		const $btn = $(this);
		const $container = $btn.is(`[data-container-id]`) ?
			$(document.getElementById($btn.attr("data-container-id"))) :
			$(".post-items-wrap > div,[data-post-items]").first();
		if ($container.length === 0)
		{
			console.error("Failed to find posts container for load more button");
			return;
		}

		if (SAVE_TO_LOCAL)
		{
			setToSavedState($container, $btn);
		}

		const $body = $(document.body);
		const $outerWrap = $btn.closest(".load-more");
		const actionName: string = $btn.attr("data-action") || defaultActionName;

		let fetching: boolean = false;
		
		let offset: number = $container.children().length;
		let postType: string = $btn.attr("data-post-type") || undefined;
		let termId: number = parseInt($btn.attr("data-term"), 10) || 0;
		let authorId: number = parseInt($btn.attr("data-author"), 10) || 0;
		let search: string = $btn.attr("data-search") || "";
		let customData: any = ((customDataJson: string) => {
			return customDataJson ? safeParseJSON(customDataJson) : undefined;
		})($btn.attr("data-custom")); // any arbitrary data passed to ajax handler, added via load-more button's updatesetting event (see below)
		
		function onFetchSuccess(res: FetchResponse): void
		{
			let $items = $();

			if (!res.html)
			{
				$btn.trigger("empty-result", {
					$container,
					res
				});
			}
			else
			{
				$items = $(res.html).filter(function () {
					return $(this).is(`[data-post-item]`);
				}).css("opacity", 0);

				$container.append($items);

				$items.each(function (index) {
					const $item = $(this);
					setTimeout(() => {
						$item.css("opacity", 1);
						if (SAVE_TO_LOCAL && (index === $items.length - 1))
						{
							saveState($container.html(), !res.more);
						}
					}, 300 * index + 50);
				});
			}

			if (res.more)
			{
				offset += $items.length;
				$btn.css({ display: '' });
			}
			else
			{
				offset = undefined;
				$btn.css({ display: 'none' });
			}

			$(document).trigger("post-items-inserted", {
				$items,
				$itemsWrap: $container,
				fetchResponse: res
			});
		}

		function disable(): void
		{
			$btn.attr("disabled", "disabled");
		}

		function enable(): void
		{
			$btn.removeAttr("disabled");
		}

		function onFetchStart(): void
		{
			fetching = true;
			disable();
			$btn.addClass("busy");
			$outerWrap.addClass("busy");
			$body.addClass("load-more-busy");
		}

		function onFetchComplete(): void
		{
			fetching = false;
			enable();
			$btn.removeClass("busy");
			$outerWrap.removeClass("busy");
			$body.removeClass("load-more-busy");
		}

		function fetch(): void
		{
			if (!fetching)
			{
				const data = { offset, termId, search, authorId, postType, customData };
				onFetchStart();
				fetchPosts(actionName, data, onFetchSuccess, onFetchComplete);
			}
		}

		$btn.on("click", (event) => {
			fetch();
			return false;
		}).on("updatesetting", function (event, data) {
			event.stopPropagation();
			each(data, (value: any, name: string) => {
				switch (name)
				{
					case "offset":
						offset = value;
						break;
					case "postType":
						postType = isArray(value) ? value.join("|") : value;
						break;
					case "termId":
						termId = value;
						break;
					case "authorId":
						authorId = value;
						break;
					case "search":
						search = value;
						break;
					case "customData":
						customData = value;
						break;
					default:
						console.error(`Bad name sent to updatesetting: ${data?.name}`);
						break;
				}
			});
		}).on("reset", function (event) {
			event.stopPropagation();
			offset = 0;
			$container.empty();
			fetch();
		});
	});
}

// For dealing with losing ajax-loaded posts after hitting back button
function setToSavedState($container, $btn): void
{
	const data = retrieveState();
	if (data)
	{
		$container.html(data.html);
		if (data.hideButton)
		{
			$btn.css({ display: 'none' });
		}
	}
}

function saveState(html: string, hideButton: boolean): void
{
	setLocalStorage("iw_load_more_" + window.location.pathname, { html, hideButton }, 3600);
}

function retrieveState(): any
{
	return getLocalStorage("iw_load_more_" + window.location.pathname);
}

export function getScrollToOffset(): number
{
	const $header = $(".main-header").first();
	if ($header.css("position") === "fixed")
	{
		return -($header.outerHeight() + 30);
	}
	return 0;
}

export function fetchPosts(actionName: string, data: any, onFetchSuccess: (res: FetchResponse) => void, onComplete?: () => void): void
{
	//console.log("fetchPosts",data);//fixme
	
	$.ajax({
		url: "/wp-admin/admin-ajax.php",
		method: "POST",
		dataType: "json",
		data: {
			action: actionName,
			data: JSON.stringify(data)
		},
		success: (res: FetchResponse) => {
			//console.log("Load more response:", res);//fixme rm
			if (res && (res.html !== undefined))
			{
				onFetchSuccess(res);
			}
			else
			{
				throw new Error(`Bad server response when trying to load more posts`);
			}
		},
		error: (x, y, z) => {
			console.error("AJAX error when trying to load more posts:", x, y, z);
		},
		complete: () => {
			if (onComplete)
			{
				onComplete();
			}
		}
	});
}
